__turbopack_context__.v({
  "attachment": "UckQla_attachment",
  "icon": "UckQla_icon",
  "spinner": "UckQla_spinner",
});
